import Axios from 'axios'

// 封装请求方法
export default {
  get: function (path = '', params = {}) {
    /*
    * 通过封装的函数会return Promise对象，通过Promise对象中的.then 方法拿到返回结果
    * resolve成功的结果，reject失败的结果
    * 详情见ES6 Promise
    * */
    return new Promise(function (resolve, reject) {
      Axios.get(path, {
        params: params
      })
        .then((response) => {
          if (response !== undefined) {
            resolve(response.data)
          }
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  post: function (path = '', params = {}, option) {
    const headers = option === undefined ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/x-www-form-urlencoded' }
    return new Promise(function (resolve, reject) {
      Axios.post(path, params, { headers: headers }
      )
        .then((response) => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  delete: function (path = '', params = {}) {
    return new Promise(function (resolve, reject) {
      Axios.delete(path, params
      )
        .then((response) => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  getImageSrc: function (path, params = {}) {
    return new Promise(function (resolve, reject) {
      Axios.get(path, {
        method: 'get',
        params: params,
        responseType: 'blob'
      })
        .then((response) => {
          resolve(response.data)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
